import React from "react";
import clsx from "clsx";

import { TNameStatus } from "../../state";

import styles from "./BoxTitle.module.scss";

export interface BoxTitleProps {
  title: string | JSX.Element;
  isArchived?: boolean;
  nameStatus?: TNameStatus;
  wrap?: boolean;
}

const BoxTitle = (props: BoxTitleProps) => {
  return (
    <span className={clsx(styles.wrapper, !props.wrap && styles.nowrap)}>
      {props.isArchived && <span className={styles.tag}>提出終了</span>}
      {props.nameStatus === "unpublish" && (
        <span className={styles.tag}>匿名共有</span>
      )}
      {props.title}
    </span>
  );
};

export default BoxTitle;
